window.addEventListener("load", (event) => {
    /**
     * Select-city on stores-page
     */
    let storeCity = 'all';
    let storeCardCity;

    $('.selectbox-dropdown#select-stores-city').on('click', 'li', function () {
        storeCity = $(this).attr('data-city');
        storeCardCity = '.store-cart-wrap[data-city="' + storeCity + '"]';

        $('.store-cart-wrap').addClass('hidden');
        $(storeCardCity).removeClass('hidden');

        if (storeCity == 'all') {
            $('.store-cart-wrap').removeClass('hidden')
        }
    });

    if (window.innerWidth <= 565) {
        $(window).scroll(function () {
            let scrollPos = $(window).scrollTop();
            if (scrollPos >= 200) {
                $('#select-stores-city').addClass('fixSearchShops');
            } else {
                $('#select-stores-city').removeClass('fixSearchShops');
            }
        });

        $(document).mouseup( function(e){ //  клик по веб-документу
            var div = $( ".googleMapFocus" ); //  ID елемента
            if ( !div.is(e.target) // клік не по нашому блоку
                && div.has(e.target).length === 0 ) { // і не по его дочірнім елементам
                div.hide();
            }
        });

        /* show maps in shop */
        $('.showMap').click(function (){
            let map = $(this).data('map');
            $('.shopMap').attr('src', map);
            $('.googleMap').addClass('googleMapFocus').removeClass('hidden');
            $('.googleMapFocus').show();

            $('.closeMap').removeClass('hidden');
        });

        $('.closeMap').click(function (){
            $('.googleMap').removeClass('googleMapFocus').addClass('hidden');
            $('.closeMap').addClass('hidden');
        });

        $('.showShops').click(function (){
            $('.shopList').removeClass('hidden').data('show-city', false);
        });
    } else {
        const widthScreen = window.innerWidth;

        if (window.location.hash.includes('#city_')) {
            const storeCity = window.location.hash.split('_')[1];
            const dropdownCity = $(`.dropdown-city[data-city-id='${storeCity}']`);
            const mapCurrentCity = dropdownCity.data('citymap');
            const dropdownCityAll = $(`.dropdown-city[data-city='all']`);

            if (!storeCity) dropdownCityAll.trigger('click');

            if (dropdownCity.length) {
                dropdownCity.trigger('click');
                $('.shopInMap').attr('src', mapCurrentCity).animate({},800);
            } else {
                console.error('City not found in dropdown.');
            }
        }

        if (window.location.hash.includes("#store_")) {
            let storeId = parseInt(window.location.hash.split('_')[1]);

            setTimeout(function() {
                $('.shopMap[data-id="' + storeId + '"]').trigger('click');
            }, 1);
        }

        $('.shopMap').click(function () {
            let chosenShop = $(this).data('map');
            let chosenImg = $(this).data('img');
            let chosenCity = $(this).data('city');
            let chosenName = $(this).data('name');
            let chosenOpen = $(this).data('open');
            let newStoreId = $(this).data('id');
            let chosenPhones = $(this).data('phones');
            window.location.hash = '#store_' + newStoreId;

            if (widthScreen > 565 && widthScreen < 992) {
                $('.storesCard').css({"height": "auto"});
                $('.storesTop').css({"height": "auto"});
                $('.shopBox').removeClass('d-none').animate({height:'auto'},1000);
            } else {
                $('.storesCard').css({"height": "800px","max-height": "900px"});
                $('.storesTop').css({"height": "800px","max-height": "900px"});
                $('.shopBox').removeClass('d-none').animate({height:300},1000);
            }

            $('.shopCity').html(chosenCity);
            $('.shopAddress').html(chosenName);
            $('.shopOpen').html(chosenOpen);
            $('.shopImg').attr('src',  ('//assets.leoceramika.com/stores/' + chosenImg));
            $('.shopInMap').attr('src', chosenShop).animate({height:500},800);
        });

        $('.dropdown-city').click(function (){
            let chosenCity = $(this).data('citymap');
            let chosenCityName = $(this).data('city');
            let chosenCityId = $(this).data('city-id');
            $('.shopInMap').attr('src', chosenCity).animate({height:600},800);

            if (widthScreen > 565 && widthScreen < 992) {
                $('.shopBox').removeClass('d-none').animate({height:'auto'},1000);
                $('.storesCard').css({"height": "auto"});
                $('.storesTop').css("height", "auto");
            } else {
                $('.shopBox').removeClass('d-none').animate({height:'300'},1000);
                $('.storesCard').css({"height": "600px","max-height": "600px"});
                $('.storesTop').css("max-height", "600px");
            }

            $('.shopBox').addClass('d-none');
            chosenCityId ? window.location.hash = 'city_' + chosenCityId : window.location.href = '/stores';
        });

        $('input#dropdownMenuButton').on('input', function () {
            $('input#dropdownMenuButton + ul .dropdown-item').hide();
            $('input#dropdownMenuButton + ul .dropdown-item:contains("' + $(this).val().toLowerCase() + '")').show();
        });

        jQuery(window).on('orientationchange', function () {
            $('.shopBox').removeClass('d-none').animate({height:'auto'},1000);
            $('.storesCard').css({"height": "auto"});
            $('.storesTop').css("height", "auto");
        });
    }
});